module.exports = __webpack_public_path__ + "static/media/user-tag.4b76318e.svg";